export default __webpack_public_path__ + "static/media/NavigateCategoryActive.d907139f.svg";